import { css } from 'emotion';

export const svgClassName = css`
  circle {
    fill: #2A2121;
  }
  rect {
    fill: #DBDBDB;
  }
`;
